import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AlertHandlerService } from '@finxone-platform/shared/services';
import { KeycloakService } from 'keycloak-angular';
import { Observable, catchError, retry, throwError, timer } from 'rxjs';
@Injectable()
export class ErrorHandlerInterceptor implements HttpInterceptor {
  constructor(
    private alertHandlerService: AlertHandlerService,
    protected keycloakService: KeycloakService,
  ) {}

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    const studioRequest = /\/projects\/[^/]+\/code(?:[/?]|$)/.test(request.url);
    const isTransient = (error: HttpErrorResponse) =>
      [0, 502, 503, 504, 521, 522, 523, 524].includes(error.status);
    return next.handle(request).pipe(
      retry({
        count: studioRequest && request.method === 'GET' ? 2 : 0,
        delay: (error: HttpErrorResponse, attempt) =>
          isTransient(error) ? timer(250 * attempt) : throwError(() => error),
      }),
      catchError((error: HttpErrorResponse) => {
        let errorMessage: any;
        if (error?.error?.message?.length) {
          if (typeof error.error.message == 'string') {
            errorMessage = error.error.message;
          } else {
            errorMessage = error.error.message[0];
          }
        } else {
          errorMessage = `Error Code: ${error.status}\nMessage: ${
            error?.error?.message ? error.error.message : 'Server Error'
          }`;
        }
        // Preview requests report errors in the pane; a global toast duplicates that message.
        const previewRequest = /\/code\/preview(?:[/?]|$)/.test(request.url);
        const transient = isTransient(error);
        if (studioRequest && transient)
          errorMessage = 'App Studio is temporarily reconnecting. Please try again shortly.';
        if (!previewRequest) this.show(errorMessage);
        if (error.status === 401) {
          this.keycloakService.login({
            redirectUri: window.location.href,
          });
        }
        // Rethrow the real response: callers branch on `status` and read the 4xx body
        // (409 merge-conflict / stale-head panels in the studio). A bare Error hid both.
        return throwError(() => error);
      }),
    );
  }

  show(errorMessage: any) {
    this.alertHandlerService.showAlertFn('error', errorMessage);
  }
}
